import React, {useEffect} from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Button, Col, Form, Row, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const NewuserMenage = () => {
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({   });
    const [l, setL] = React.useState(false);
    const [villas, setVilla] =  React.useState([]);
    const [valueVilla, setValueVilla] = React.useState(null);
        
    const navigate = useNavigate();
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === false) {
            return;
        }
        setValidated(true);
        setL(true);

        let d = formd;
        d.create_At = new Date();
        d.update_At = new Date();
        firebase.firestore().collection('usersMenage').add(d).then(() => {
            console.log("Document successfully written!");
            toast.success("Utilisateur créer avec succès");
            navigate('/usersmenage');
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

        // try{
        //     firebase.auth().createUserWithEmailAndPassword(formd.email, formd.password)
        //     .then((userCredential) => {
        //         // Signed in 

        //     })
        //     .catch((error) => {
        //         var errorCode = error.code;
        //         var errorMessage = error.message;
        //         // ..
        //         setL(false); 
        //         toast.error(errorMessage);
        //     });
        // }catch (error){
        //     toast.error(error);
        // }
    };


    const handleChange = e => {
        let d = formd;
        // console.log(e.target, e.target.checked);  
        d[e.target.name] = e.target.value; 
        setFrom(d);
    };



      const loadVilla = () => { 
        firebase.firestore().collection('properties').get().then((snap)=> {
          let s = [];
          snap.forEach((d) => {
            var l = d.data(); 
            if (l?.delete){
              // supprimer donc ne pas affiché
            }else{ 
                const dr = {value : d.id, label: `${l?.nameHouse}`  }
                s.push(dr) 
            }
            
          })
          setVilla(s); 
        }).catch((error) => {
          setL(false); 
          var errorMessage = error.message;
          toast.error(errorMessage);
        })
      }

       useEffect(() =>{ 
          loadVilla() 
        }, []);
      

    return (
        <FalconComponentCard>
            <FalconComponentCard.Header title="Nouveau service de ménage" light={false} noPreview={true} />
            <FalconComponentCard.Body >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="4" controlId="exampleFirstName">
                            <Form.Label>Prénom</Form.Label>
                            <Form.Control
                                onChange={handleChange}
                                required
                                name="firstName"
                                minlength="3"
                                type="text"
                                placeholder="Prénom"
                            />
                            <Form.Control.Feedback type="invalid">
                                Veuillez indiquez votre Prénom.
                            </Form.Control.Feedback>
                            <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="exampleLastName">
                            <Form.Label>Nom de famille</Form.Label>
                            <Form.Control
                                required
                                minlength="3"
                                type="text"
                                name="lastName"
                                onChange={handleChange}
                                placeholder="Nom de famille"
                            />
                            <Form.Control.Feedback type="invalid">
                                Veuillez indiquez votre nom de famille.
                            </Form.Control.Feedback>
                            <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="exampleUserName">
                            <Form.Label>Email</Form.Label>
                            <InputGroup hasValidation>
                                <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    aria-describedby="inputGroupPrepend"
                                    required
                                    onChange={handleChange}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Veuillez indiquez l'email.
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                    </Row>
                    <Row className="mb-3">
                        <Form.Group as={Col} md="3" controlId="phone">
                            <Form.Label>Téléphone</Form.Label>
                            <Form.Control
                                name="phone"
                                onChange={handleChange} type="phone" placeholder="Téléphone" minlength="10" />
                            <Form.Control.Feedback type="invalid">
                                Téléphone invalide.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>

                    
                <Row  className="mb-3">
                <Form.Group as={Col} md="5" controlId="villa">
                <Form.Label>Propriétés</Form.Label>
                <Select 
                        options={villas}
                        isMulti
                        closeMenuOnSelect={false}
                        placeholder='Choisir les villas...' 
                        classNamePrefix="react-select"
                        value={valueVilla}
                        onChange={value => {
                            setValueVilla(value)
                            let d = formd;
                            d['villas'] = value;
                            setFrom(d);
                        
                        }}
                        />
                </Form.Group>
                </Row>
                    <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Créer'}</Button>
                </Form>
            </FalconComponentCard.Body>
        </FalconComponentCard>
    );
    //   <> 

    //     <FalconComponentCard>
    //       
    //       <FalconComponentCard.Body code={exampleCode} language="jsx" />
    //     </FalconComponentCard> 
    //   </>
};

export default NewuserMenage;
